// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".spinner[data-v-c6c6caa0]{display:grid;grid-template-columns:1fr;align-items:center;height:100vh;background-color:#f8f8f8;filter:grayscale(100%);opacity:0.08}img[data-v-c6c6caa0]{max-width:75px;margin:0 auto;text-align:center}\n", ""]);
// Exports
module.exports = exports;
